import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import Button from '../../components/common/Button';
import FormField from '../shared/FormField';
import { courtTypesApi } from '../../api/facades';

const inputClass = 'w-full rounded-lg border border-gray-300 bg-white dark:bg-slate-800 dark:border-gray-600 py-2 px-3 text-sm text-slate-700 dark:text-slate-200 focus:border-primary-300 focus:outline-none';

const CourtTypeCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [court_type_name, setCourtTypeName] = useState('');
  const [is_active, setIsActive] = useState<'Yes' | 'No'>('Yes');

  const create = useMutation({
    mutationFn: () => courtTypesApi.create({ court_type_name, is_active }),
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['court-types'] });
      const id = data?.data?.id ?? (data?.data && (data.data as any).id);
      if (id) navigate(`/dashboard/settings/court-types/${id}`);
      else navigate('/dashboard/settings/court-types');
      toast.success('Court created.');
    },
    onError: (e: any) => toast.error(e?.message || 'Create failed.'),
  });

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!court_type_name.trim()) return;
    create.mutate();
  };

  return (
    <div className="bg-white dark:bg-slate-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
      <h1 className="text-xl font-bold text-slate-700 dark:text-slate-200 mb-4">New Court</h1>
      <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <FormField label="Name">
            <input className={inputClass} value={court_type_name} onChange={(e) => setCourtTypeName(e.target.value)} placeholder="e.g. High Court" required />
          </FormField>
        </div>
        <FormField label="Active">
          <select className={inputClass} value={is_active} onChange={(e) => setIsActive(e.target.value as 'Yes' | 'No')}>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </FormField>
        <div className="md:col-span-2 flex gap-2 mt-2">
          <Button variant="secondary" type="button" onClick={() => navigate(-1)}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={!court_type_name.trim() || create.isPending}>{create.isPending ? 'Creating…' : 'Create'}</Button>
        </div>
      </form>
    </div>
  );
};

export default CourtTypeCreatePage;
